export const TYPE_REDUCER = {
    SET_INITIALIZATION_THREEKIT: 'set initialization threekit',
    SET_ALL_SETTING_CONFIG: 'set all setting config',
    CHANGE_STEP: 'change main step',
    CHANGE_VIEW: 'change view',
    MODAL_SWITCHING: 'Modal switching open or clos',
    SET_VALUE_OPTIONS: 'set value options',
    SET_VALUE_MULTIPLE_OPTIONS: 'set value multiple options',
    UPDATE_SETTINGS: 'update settings',
    SHOW_NOTIFICATION: 'show notification',
    CLOSE_NOTIFICATION: 'close notification',
    SET_ACTIVE_THREEKIT_PARAMS: 'set active threekit params',
    SET_SIDE_OPTION_ARRAY: 'set side option array',
    SET_OPEN_SECTION_ID_IN_SIDES: 'set open section id in section',
    REMOVE_TEMP_SECTION: 'remove temp section',
}